import * as React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useLocation, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { InputAdornment } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import Typography from '@mui/material/Typography';
import mepcoLogo from '../../../images/mepcoLogo.png';
import pitcLogo from '../../../images/pitcLogo.png';
import usLogo from '../../../images/usLogo.png';
import './resetpassword.scss'
import { cfpBaseUrl } from '../../../network/urls';
import { useFormik } from 'formik';
import { resetpasswordSchema } from "../../../schemas/resetpassword"
import { CircularProgress } from '@mui/material';
import { Link } from 'react-router-dom';

const initialValues = {

    password: "",
    confirmpassword: "",

};

const Resetpassword = () => {
    const navigate = useNavigate();

    const { state } = useLocation();
    let Username = state;
    const [isLoadingSpinner, setIsLoadingSpinner] = React.useState(false);



    const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
        useFormik({
            initialValues,
            validationSchema: resetpasswordSchema,
            onSubmit: async () => {
                setIsLoadingSpinner(true);
                var formdata = new FormData();
                formdata.append("userId", Username);
                formdata.append("password", values.password);

                var requestOptions = {
                    method: 'POST',
                    body: formdata,
                    redirect: 'follow',
                };

                await fetch(cfpBaseUrl + "customerFaciliationPortal/setNewPassword", requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status === "200") {
                            setIsLoadingSpinner(false);
                            // toast.success(result.message)
                            navigate("/")
                        }
                        else {
                            setIsLoadingSpinner(false);
                        }
                    })
                    .catch(error => {
                        setIsLoadingSpinner(false);
                        console.log(error)
                    });
            }
        })
    return (
        <>
            <Grid className='reset-password-background'>
                <div className='reset-password-form'>
                    <img src={mepcoLogo} alt="" className='logo' />
                    <Typography component="h1" variant="h5" className='title'>
                        Reset Password
                    </Typography>
                    <Box className='form-fields'>
                        <TextField
                            margin="normal"
                            className='textfield'
                            type="password"
                            required
                            fullWidth
                            value={values.password}
                            name="password"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start" className='input-adornments'>
                                        <LockIcon className='icon' />
                                    </InputAdornment>

                                )
                            }}
                            id="password"
                            label=""
                            placeholder='New Password'
                            autoComplete=""
                            size='small'

                        />
                        {errors.password && touched.password ? (
                            <p className="form-error">{errors.password}</p>
                        ) : null}
                        <Box>

                            <TextField

                                margin="normal"
                                className='textfield'
                                type="password"
                                required
                                fullWidth
                                value={values.confirmpassword}
                                name="confirmpassword"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start" className='input-adornments'>
                                            <LockIcon className='icon' />
                                        </InputAdornment>
                                    ),
                                }}
                                id="confirmpassword"
                                label=""
                                placeholder='Confirm Password'
                                autoComplete=""
                                size='small'
                            />
                            {errors.confirmpassword && touched.confirmpassword ? (
                                <p className="form-error">{errors.confirmpassword}</p>
                            ) : null}
                        </Box>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            className='button'
                            onClick={handleSubmit}
                            disabled={isLoadingSpinner}
                            sx={{
                                mt: 3,
                                mb: 2,
                                fontSize: 'small',
                                height: 40,
                                textTransform: 'capitalize'
                            }}
                        >
                            {isLoadingSpinner ? (
                                <Box sx={{ display: 'flex' }}>
                                    <CircularProgress />
                                </Box>
                            ) : (
                                'Submit'
                            )}
                        </Button>
                        < ToastContainer autoClose={5000} style={{ width: '50%' }} theme="colored" />
                        <Grid className='powered-by'>
                            <Box className='form-bottom-link'>
                                <Link to='/'  >
                                    Cancel
                                </Link>
                            </Box>
                            <Grid className='logos'>
                                <img className='usaid' src={usLogo} alt="" />
                                <img className='pitc' src={pitcLogo} alt="" />
                            </Grid>
                        </Grid>
                    </Box>
                </div>
            </Grid>
        </>
    );
}

export default Resetpassword;